import { cardsData } from '@/mocks/homeData';

const imageUrls = [
  'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20drama%20ancient%20costume%20romantic%20scene%20with%20flowing%20silk%20warm%20candlelight%20atmospheric%20palace%20interior%20soft%20golden%20lighting%20cinematic%20composition%20emotional%20drama&width=600&height=400&seq=card-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Mysterious%20crime%20scene%20investigation%20with%20evidence%20board%20red%20string%20connections%20dim%20lighting%20noir%20atmosphere%20cinematic%20framing%20tension%20and%20intrigue%20film%20noir%20style&width=600&height=400&seq=card-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Korean%20drama%20emotional%20scene%20with%20rain%20city%20lights%20reflection%20on%20wet%20street%20melancholic%20mood%20soft%20blue%20tones%20cinematic%20anamorphic%20composition%20romantic%20sadness&width=600&height=400&seq=card-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Chinese%20animation%20action%20scene%20with%20supernatural%20powers%20energy%20effects%20traditional%20ink%20painting%20style%20merged%20with%20modern%20animation%20dynamic%20composition%20vibrant%20colors&width=600&height=400&seq=card-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Science%20fiction%20space%20scene%20with%20three%20suns%20galaxy%20nebula%20cosmic%20scale%20dramatic%20astronomical%20phenomena%20cinematic%20sci-fi%20epic%20composition%20dark%20vast%20universe%20stars&width=600&height=400&seq=card-05&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Hong%20Kong%20cinema%20classic%20movie%20scene%20with%20neon%20signs%20narrow%20streets%20at%20night%20rain%20reflections%20retro%20atmosphere%20cinematic%20street%20photography%20warm%20nostalgic%20tone%20vintage%20feel&width=600&height=400&seq=card-06&orientation=landscape',
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          热门推荐
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardsData.map((item, i) => (
            <div
              key={i}
              className="group bg-background-100 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={imageUrls[i]}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    (e.currentTarget.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-[11px] font-semibold whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}